export default function getMatchedFacets(
  facets: string[],
  groupedFacets: Record<string, string[]>,
  item: { listFacetIdAttribute?: string[] }
) {
  const matchesFacets =
    facets.length === 0 ||
    Object.keys(groupedFacets).every((prefix) => {
      const group = groupedFacets[prefix]
      // Check if item matches any facet in the group (inclusive within the group)
      const matchesGroup = item.listFacetIdAttribute?.some((facet) =>
        group.includes(facet)
      )
      return matchesGroup
    })

  return matchesFacets
}
